import { compose } from 'redux';
import { branch } from '../utils/general/branch';

import {
	withListQuery,
	withListActions,
	withListActionsFrontEnd,
	withBulkActions,
	withNoListQuery,
	withListContextToProps,
	withListPropsToContext,
	withModifyMutation,
	withListSettings,
} from './helpersListContainer';
import withSetFilteredCount from './helpersListContainer/withSetFilteredCount';

import { withSubscription } from './helpersShared/withSubscription';

export const ListContainer = (WrappedComponent) => {
	return compose(
		withListSettings,
		branch(props => props.subscription, withSubscription),
		branch(props => props.query, withListQuery, withNoListQuery),
		branch(props => props.frontEnd, withListActionsFrontEnd, withListActions),
		branch(props => props.bulkActions, withBulkActions),
		branch(props => props.modifyMutation, withModifyMutation),
		withListPropsToContext,
		withListContextToProps, // Passes most common context items to props
		withSetFilteredCount,
	)(WrappedComponent);
};

